module.exports = "<hybse-admin-listusers [userType]=\"'DemoIssuer'\">\n\n</hybse-admin-listusers>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/demo-issuers/demo-issuers.component.html
// module id = ../../../../../src/app/components/pages/demo-company/demo-issuers/demo-issuers.component.html
// module chunks = main